export default "__VITE_ASSET__739927f4__"